import { postPhoneVerifications } from "../../../../app/api/phoneUpdation";
import { BaseAction } from "../../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { IPhoneNumberVerifications } from "../../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import { IPhoneNumberVerifyActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/PhoneNumberVerifyActionParams";


class PhoneNumberVerifyAction extends BaseAction<IDefaultActionResult, IPhoneNumberVerifyActionParams> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: [],
            message: "",
            status: "fail"
        }
        try {
            const { customerId, phoneNumber } = this.params!;            
            if (customerId && phoneNumber && phoneNumber != "") {
                updateRecoilState("otpErrorAtom", "");
                updateRecoilState("isOtpVerifiedAtom", false);
                const payload = {
                    phoneNumber: "+" + phoneNumber
                }
                const response: any = await postPhoneVerifications(customerId, payload);
                if (response.status === 'ok' && response.answer) {
                    const phoneNumberResponse: IPhoneNumberVerifications = response.answer;
                    updateRecoilState("phoneVerificationResponseAtom", phoneNumberResponse)
                    actionResult.status = "success"
                    actionResult.data = phoneNumberResponse
                }
            }
        } catch (error) {
            console.error("Error in PhoneNumberVerifyAction:", error);
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}

export const phoneNumberVerifyAction = new PhoneNumberVerifyAction()


